document.addEventListener('click', async function (e) {
    const btnModalEliminarTurno = e.target.closest('#btnModalEliminarTurno');
    if (!btnModalEliminarTurno) return;

    const idTurno       = btnModalEliminarTurno.getAttribute("data-id");
    const formEliminar  = document.querySelector("#formEliminarTurno");
    const modalEliminar = document.querySelector("#ModalEliminarTurno");

    if (!idTurno || !formEliminar || !modalEliminar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para eliminar el turno.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/turnos/infoTurno?idTurno=${idTurno}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del turno.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEliminar.classList.add('modal--show');

        const inputIdTurno    = formEliminar.querySelector('#idTurnoEliminar');
        const strongNombre    = modalEliminar.querySelector('#nombreEliminarTurno');

        if (inputIdTurno) inputIdTurno.value    = data.idTurno     || "";
        if (strongNombre) strongNombre.textContent = data.nombreTurno || "";

    } catch (error) {
        console.error("Error al obtener información del turno:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del turno.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEliminarTurno') {
        e.preventDefault();
        const formulario    = e.target;
        const modalEliminar = document.querySelector("#ModalEliminarTurno");
        const btnSubmit     = formulario.querySelector('#btnEliminarTurno');
        const spinner       = formulario.querySelector('#spinner');
        const formData      = new FormData(formulario);
        if (!formulario || !modalEliminar || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para eliminar el turno.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/turnos/eliminar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1000);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
                modalEliminar.classList.remove('modal--show');
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Turno eliminado correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            modalEliminar.classList.remove('modal--show');
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
